import dayjs from "dayjs"

export const FAILED_WORKFLOW_WINDOW_DAYS = 7

// Shared by the Action Needed bell and the workflow dashboard default range so both count the same failures.
export const failedWorkflowWindowStart = () =>
  dayjs()
    .subtract(FAILED_WORKFLOW_WINDOW_DAYS - 1, "day")
    .startOf("day")
